
<span v-on:click="$emit(`click`)" class="schedule-badge" :style="style">{{ scheduleName }}</span>
